/* "We find the money" on the landing page: the scholarships PathsAbroad checks for every student, and what the page's
   example student (Amina, from Amman, the same as How it works) can apply for. The numbers come from the planner's
   research (scholarships.ts, written by apps/planner/prototype/scripts/gen_v41.py; test/unit/landing.test.ts keeps them true).
   What a student can get is said honestly: how many, and the most one is worth a year, never a sum. A program for one
   university (Gates Cambridge, Rhodes at Oxford) names it. */
import { WEB_ROUTES } from '@pathabroad/core/browser';
import { useT } from '../../app/i18n';
import { Icon } from '../../app/icons';
import { countryName, localeOf } from '../../lib/format';
import { COUNTRIES } from './facts';
import { EXAMPLE, SCHOLARSHIPS, SCH_BIGGEST } from './scholarships';

export function Money() {
  const { t, lang } = useT();
  const loc = localeOf(lang);
  const n = (v: number) => new Intl.NumberFormat(loc).format(v);
  /* rounded, as the planner shows them (most values are estimates): US$74K */
  const usd = (v: number) => new Intl.NumberFormat(loc, { style: 'currency', currency: 'USD', notation: 'compact', maximumFractionDigits: 0 }).format(v);
  return (
    <section id="money" className="land-section land-money" aria-labelledby="money-title">
      <div className="land-wrap money-grid">
        <div className="money-copy">
          <p className="land-eyebrow money-eye"><Icon.spark />{t('land.money.eyebrow')}</p>
          <h2 id="money-title" className="land-h2">{t('land.money.title')}</h2>
          <p className="land-sub">{t('land.money.lead', { n: n(SCHOLARSHIPS), countries: n(COUNTRIES) })}</p>
          <ul className="money-stats">
            <li><b className="num">{n(SCHOLARSHIPS)}</b><span>{t('land.money.s1')}</span></li>
            <li><b className="num">{usd(SCH_BIGGEST)}</b><span>{t('land.money.s2')}</span></li>
            <li><b className="num">{n(COUNTRIES)}</b><span>{t('land.money.s3')}</span></li>
          </ul>
        </div>
        <article className="money-card" aria-labelledby="money-ex">
          <p className="money-card__eye">{t('land.money.ex_eyebrow')}</p>
          <h3 id="money-ex" className="money-card__who">{t('land.money.ex_who')}</h3>
          <p className="money-card__v">{t('land.money.ex_v', { n: n(EXAMPLE.n), amt: usd(EXAMPLE.max) })}</p>
          <ul className="money-card__list">
            {EXAMPLE.top.map(s => (
              <li key={s.id}>
                <span className="money-card__name">{lang === 'ar' ? s.ar : s.en}
                  <small>{s.uni ? (lang === 'ar' ? s.uni.ar : s.uni.en) : s.dest === 'EU' ? t('land.money.eu') : s.dest.length === 2 ? countryName(s.dest, lang) : t('land.money.intl')}</small></span>
                <b className="num">{t('land.money.peryear', { amt: usd(s.usd) })}</b>
              </li>
            ))}
          </ul>
          <a className="btn btn--primary land-btn money-card__cta" href={WEB_ROUTES.planner}>{t('land.money.cta')}</a>
        </article>
      </div>
      <p className="land-wrap money-fine">{t('land.money.fine')}</p>
    </section>
  );
}
